import { render, staticRenderFns } from "./fieldIdSelector.vue?vue&type=template&id=f64b5544&scoped=true&lang=pug&"
import script from "./fieldIdSelector.vue?vue&type=script&lang=js&"
export * from "./fieldIdSelector.vue?vue&type=script&lang=js&"
import style0 from "./fieldIdSelector.vue?vue&type=style&index=0&id=f64b5544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b5544",
  null
  
)

export default component.exports